import React, { useEffect, useState, useCallback } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { Capacitor } from "@capacitor/core";

import { auth_token, survey_id, tab, historyStack } from "../atomstore/store";
import { setContext, setUserId } from "../crashlyticsMethods";
import { getActiveChild, getParent, getUserState, getAppCurrentVersion } from "../atomstore/serviceAtoms";
import Constants from "../constant";
import manifest from "../manifest.json";

import Login from "../components/auth/Login";
import AppLayout from "./AppLayout";

import useBackButton from "../useBackButton";
import { App as CapApp } from "@capacitor/app";

const AppRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const authToken = localStorage.getItem("auth_token")
    const [surveyId] = useAtom(survey_id);
    const [activeTab, setActiveTab] = useAtom(tab);
    const [navStack, setNavStack] = useAtom(historyStack);

    const [selectedPhoto, setSelectedPhoto] = useState(null);

    console.log("authToken", authToken);

    // Add route to stack on route change
    useEffect(() => {
        setNavStack(prev => [...prev, location.pathname]);
    }, [location.pathname]);

    const goBack = useCallback(() => {
        if (selectedPhoto) {
            setSelectedPhoto(null);
            return;
        }

        if (surveyId !== -1) {
            navigate("/home");
            return;
        }

        if (navStack.length > 1) {
            const prevRoute = navStack[navStack.length - 2];
            setNavStack(stack => stack.slice(0, -1));
            navigate(prevRoute);
            return;
        }

        CapApp.exitApp();
    }, [selectedPhoto, surveyId, navStack]);

    useBackButton(goBack);

    // Update crashlytics context when user data changes
    useEffect(() => {
        if (!Capacitor.isNativePlatform() || !authToken) return;

        // Read from store directly 
        const user = getUserState();
        const parent = getParent();
        const activeChild = getActiveChild();
        const appVersion = getAppCurrentVersion();

        if (user || parent || activeChild) {
            const contextData = {
                parentDetails: parent,
                lastLoginUI: user?.lastLoggedIn,
                loggedInUserData: {
                    email: user?.email,
                    password: user?.password,
                    phone: user?.phone,
                },
                apiVersion: appVersion,
                uiVersion: Constants.env.version || manifest.version
            };
            setContext("UserData", contextData);

            if (activeChild?.id) {
                setUserId(activeChild.id);
            }
        }
    }, [authToken]); // Update when auth  changes


    // --------------------------
    // 🚀 ROUTE PROTECTION LOGIC
    // --------------------------
    const RequireAuth = ({ children }) => {
        console.log("authtoken before", authToken)
        console.log(authToken === "");
        if (!authToken || authToken === '""') {
            console.log("inside RequireAuth");
            return <Navigate to="/login" replace />;
        }
        console.log("authtoken inside require check", authToken)
        return children;
    };

    return (
        <div className="h-full bg-gray-50">

            <Routes>

                {/* LOGIN ROUTE */}
                <Route path="/login" element={<Login />} />

                {/* PROTECTED ROUTES */}
                <Route
                    path="/*"
                    element={
                        <RequireAuth>
                            <AppLayout
                                selectedPhoto={selectedPhoto}
                                setSelectedPhoto={setSelectedPhoto}
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                            />
                        </RequireAuth>
                    }
                />

            </Routes>
        </div>
    );
};
export default AppRoutes;